import _ from "lodash"

export function getPointSymbolLayerConfig(config) {
    const baseConfig = {
        type: "symbol",
        filter: [
            "all",
            ["==", ["geometry-type"], "Point"],
            ["!", ["has", "point_count"]],
        ],
        layout: {
            "icon-allow-overlap": true,
            "icon-ignore-placement": true,
        },
    }

    return _.merge(baseConfig, config)
}

export function getPointCircleLayerConfig(config, filters = null) {

    const baseFilter = [
        ["==", ["geometry-type"], "Point"],
        ["!", ["has", "point_count"]],
    ]

    const finalFilter = filters && filters.length > 0
        ? ["all", ...baseFilter, filters]
        : ["all", ...baseFilter]

    const baseConfig = {
        type: "circle",
        filter: finalFilter,
    }

    return _.merge(baseConfig, config)
}